'use strict';

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, '__esModule', {
  value: true
});

require('revalidator');

require('./ValidatorService.js');

var AjaxAction = require('./AjaxAction.js');

var EndpointService = require('./EndpointService.js');

require('./AutoParser.js');

require('./HttpInterface.js');

var XhrHttpIO = require('./XhrHttpIO.js');

var ActiveRequester = require('./ActiveRequester.js');

var AjaxReducer =
/*#__PURE__*/
function () {
  function AjaxReducer(_ref) {
    var reducerParams = _ref.reducerParams;
    this.reducerParams = reducerParams;
  }

  var _proto = AjaxReducer.prototype;

  _proto.reduce = function reduce(data) {
    return {
      data: data,
      reducerParams: this.reducerParams
    };
  };

  return AjaxReducer;
}();

var AjaxHandler =
/*#__PURE__*/
function () {
  function AjaxHandler(options) {
    if (!options.action && !options.endpointDefinition) {
      throw new Error('endpointDefinition param is required if no action param is passed');
    }

    this.apiPrefix = options.apiPrefix;
    this.action = options.action || AjaxAction.AjaxAction;
    this.reducer = options.reducer || AjaxReducer;
    this.reducerParams = options.reducerParams || [];
    this.errorHandler = options.errorHandler;
    this.sessionStoreCookie = options.sessionStoreCookie; // CV

    this.tokenCookie = options.tokenCookie; // JRP

    this.endpointDefinition = options.endpointDefinition;
    this.endpointService = options.endpointService || EndpointService.EndpointService; // TODO remove

    var isActiveRequest = options.endpointDefinition && options.endpointDefinition.activeRequestConfig;
    this.httpIo = options.httpIo || (isActiveRequest ? ActiveRequester.ActiveRequester : XhrHttpIO.XhrHttpIO); // TODO use httpParams

    this.httpIoParams = options.httpIoParams || undefined;

    if (options.httpParams) {
      this.httpParams = options.httpParams;
    }
  }

  var _proto2 = AjaxHandler.prototype;

  _proto2.customAction = function customAction(requestParams) {
    var httpIoInstance = this.getHttpIoInstance();
    var endpointService = new this.endpointService(httpIoInstance);
    var Action = this.action;
    var action = new Action(endpointService, this.endpointDefinition);
    var invoke = action.invoke(requestParams);
    invoke["catch"](this.onActionInvokeError.bind(this));
    return invoke.then(this.reduceResult.bind(this));
  };

  _proto2.getHttpIoInstance = function getHttpIoInstance() {
    return new this.httpIo(Object.assign({
      sessionStoreCookieFactory: this.sessionStoreCookie,
      tokenCookie: this.tokenCookie,
      apiPrefix: this.apiPrefix,
      httpParams: this.httpParams
    }, this.httpIoParams));
  };

  _proto2.reduceResult = function reduceResult(actionResult) {
    var Reducer = this.reducer;
    var reducer = new Reducer({
      reducerParams: this.reducerParams
    });
    return reducer.reduce(actionResult, this.reducerParams);
  };

  _proto2.onActionInvokeError = function onActionInvokeError(err) {
    this.errorHandler({
      className: "AjaxHandler-" + this.action.name,
      funcName: 'onActionInvokeError',
      err: err
    });
    return err;
  };

  return AjaxHandler;
}();

exports.AjaxHandler = AjaxHandler;